export const TEST_ID = 'updateBoundaryForm';

export const BOUNDARY_NAME_FIELD_NAME = 'name';
